import useAIJobChannel from 'hooks/useAIJobChannel';
import useInvalidateQueries from 'hooks/useInvalidateQueries';
import AIJob from 'models/AIJob';

type SummaryJobSubscriberProps = {
  job: AIJob;
};

export default function SummaryJobSubscriber({ job }: SummaryJobSubscriberProps) {
  const invalidateQueries = useInvalidateQueries();

  useAIJobChannel({
    aiJobId: job?.isProcessing ? job.id : undefined,
    onMessageReceived: (updatedJob) => {
      if (updatedJob.isProcessing) return;

      invalidateQueries({ summarizations: true });
    },
  });

  return null;
}
